module.exports = "<template>\n    <div show.bind=\"show\">\n        <slot></slot>\n    </div>\n</template>\n";